export default __webpack_public_path__ + "static/media/rocks-02.60c40bb7.png";